import * as React from "react";

import "./inline-select.scss";

import {cs} from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";
import {keyed} from "@Common/react/keyed";
import {cx} from "emotion";
import {AnyAction} from "@Common/react/any-action";

export const InlineSelect = ({
    label, 
    items, 
    disabled=false,
}) => cs(
    ["showingDropdown", (_, next) => UseState({next})],
    ({showingDropdown}) => (
        <div className={cx("inline-select inline-select-7z3", {showingDropdown: showingDropdown.value})}>
            <div className="toggle" onClick={() => !disabled && showingDropdown.change(v=>!v)} xd-qa-type="dropdown" xd-qa-name={label}>
                <div className={cx("background")}>
                    <i className={cx("fa", !showingDropdown.value ? "fa-caret-down" : "fa-caret-up")} xd-qa-type="icon" xd-qa-name="Caret"/>
                </div>
                <div className="text">
                    {label}
                </div>
            </div>

            {showingDropdown.value && AnyAction({
                action: () => showingDropdown.onChange(false),
            })}

            {showingDropdown.value && (
                <div className="dropdown">
                    {items.map((item, i) => cs(
                        keyed(i),
                        () => (
                            <div className="item" onClick={() => item.onSelect()} xd-qa-type="dropdown_item" xd-qa-name={item.label}>
                                {item.label}
                            </div>
                        )
                    ))}
                </div>
            )}
        </div>
    ),
);
